import React from 'react';
export function SocialProofSection() {
  return <section className="py-24 bg-blue-soft/30" data-id="element-141">
      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 text-center" data-id="element-142">
        <h2 className="text-3xl md:text-4xl font-bold text-ink mb-8" data-id="element-143">
          You're not alone.
        </h2>

        <div className="space-y-6 text-lg md:text-xl text-ink/80 leading-relaxed" data-id="element-144">
          <p data-id="element-145">
            So many men and women 40+ are quietly dealing with this same
            bloating struggle. It's not just about weight—it's about feeling
            good in your body again.
          </p>
          <p data-id="element-146">
            Thousands of people are turning to simple, calming approaches like
            this one.
          </p>
          <p className="font-semibold text-ink text-xl md:text-2xl mt-8 font-serif" data-id="element-147">
            And now it's your turn to give your belly the reset it's been
            craving.
          </p>
        </div>
      </div>
    </section>;
}